import '../../App.css';
import './homepage.css'
import PopText from '../PopText/PopText';
import ZCap from '../KeyCaps/ZCap';
import KeyCap from '../KeyCaps/KepCap';
import { projectGroups, workExperiences } from '../pages/pages';
import TextDescription from '../TextDescription/TextDescription';
import * as iconSVGs from '../assets/icons/index';
import DiamondCaps from '../DiamondCaps/DiamondCaps';

/**
 * Component of the homepage that holds the buttons to project and about 
 * @returns React Component
 */
const HomePage = () => {
  window.scroll(0, 0);
  return (
    <div>
      <div className='home-title'>
        <PopText>
          Zaid Arshad
        </PopText>
        <div className='home-title-sub'>
          Software Developer
        </div>
      </div>

      <div className='z-logo'>
        <ZCap />
      </div>

      <div className='project-tab'>
        <PopText>
          Work Experiences
        </PopText>
        {
          workExperiences.map((page) =>
            <KeyCap key={page.key} page={page} />
          )
        }

        <PopText>
          Mobile Apps
        </PopText>
        {
          projectGroups.mobile.map((project) =>
            <KeyCap key={project.key} page={project} title={project.name} tags={[project.description, ...project.languages]} />
          )
        }

        <PopText>
          Games
        </PopText>
        {
          projectGroups.games.map((project) =>
            <KeyCap key={project.key} page={project} title={project.name} tags={[project.description, ...project.languages]} />
          )
        }

        <PopText>
          Tools
        </PopText>
        {
          projectGroups.tools.map((project) =>
            <KeyCap key={project.key} page={project} title={project.name} tags={[project.description, ...project.languages]} />
          )
        }
      </div>

      <div className='about'>
        <TextDescription title='About Me'>
          Pursuing a degree in computer science at Simon Fraser University.
          Currently have 20 months of professional experience as a developer from EA, Sony and Safe Software.
          As shown in my projects, I have developed skills for frontend, backend, game, web, and mobile development.
        </TextDescription>

        <div className='external-links'>
          <DiamondCaps Front={iconSVGs.LinkedinFront} Back={iconSVGs.LinkedinBack} link={'https://www.linkedin.com/in/zaid-arshad-882b12227/'} />
          <DiamondCaps Front={iconSVGs.GithubFront} Back={iconSVGs.GithubBack} link={'https://github.com/ZaidArshad'} />
          <DiamondCaps Front={iconSVGs.EmailFront} Back={iconSVGs.EmailBack} link={'mailto:zaidy.arshad@gmail.com'} />
          <DiamondCaps Front={iconSVGs.CVFront} Back={iconSVGs.CVBack} link='resumes/dev-resume.pdf' />
        </div>
      </div>
    </div>
  )
}

export default HomePage